// extracted by mini-css-extract-plugin
export default {"container":"oP1CsYKn"};